import React from "react";
// import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { createTheme, SvgIcon, Switch } from "@mui/material";
import { ThemeProvider } from "@mui/styles";
const theme = createTheme({
  palette: {
    secondary: { main: "#009a00" },
  },
  overrides: {
    MuiSwitch: {
      thumb: {
        color: "red",
      },
      track: { backgroundColor: "#f00" },
    },
  },
});
export const EOCSwitch = ({ checked = false, onChange, disabled }) => {
  const r = 11;
  return (
    <ThemeProvider theme={theme}>
      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        icon={
          <SvgIcon height={2 * r} width={2 * r}>
            <circle
              cx={r}
              cy={r}
              r={r}
              fill="red"
              display={disabled ? "none" : ""}
            />
          </SvgIcon>
        }
        checkedIcon={
          <SvgIcon height={2 * r} width={2 * r}>
            <circle
              cx={r}
              cy={r}
              r={r}
              fill="green"
              display={disabled ? "none" : ""}
            />
          </SvgIcon>
        }
      />
    </ThemeProvider>
  );
};
